type FullscreenCapableElement = Element & {
  webkitRequestFullscreen?: () => Promise<void> | void;
  mozRequestFullScreen?: () => Promise<void> | void;
  msRequestFullscreen?: () => Promise<void> | void;
};

const getFsElement = () =>
  document.fullscreenElement ||
  (document as Document).webkitFullscreenElement ||
  (document as Document).mozFullScreenElement ||
  (document as Document).msFullscreenElement ||
  null;

export async function requestPageFullscreen() {
  const el = document.documentElement as unknown as FullscreenCapableElement;
  try {
    if (el.requestFullscreen) return await el.requestFullscreen();
    if (el.webkitRequestFullscreen) return await el.webkitRequestFullscreen();
    if (el.mozRequestFullScreen) return await el.mozRequestFullScreen();
    if (el.msRequestFullscreen) return await el.msRequestFullscreen();
    throw new Error("Fullscreen API not supported");
  } catch (e) {
    console.error("[requestPageFullscreen] failed:", e);
  }
}

export async function exitPageFullscreen() {
  try {
    if (document.exitFullscreen) return await document.exitFullscreen();
    if (document.webkitExitFullscreen)
      return await document.webkitExitFullscreen();
    if (document.mozCancelFullScreen)
      return await document.mozCancelFullScreen();
    if (document.msExitFullscreen) return await document.msExitFullscreen();
  } catch (e) {
    console.error("[exitPageFullscreen] failed:", e);
  }
}

export async function togglePageFullscreen() {
  if (getFsElement()) return exitPageFullscreen();
  return requestPageFullscreen();
}
